import React from "react"

function SubscriptionPayment() {
  return <div>SubscriptionPayment</div>
}

export default SubscriptionPayment
